<template>
    <div class="private-lifestyle">
        <div class="private-lifestyle__header">
            <div class="container">
                <div class="private-lifestyle__header-content">
                    <slot name="head"></slot>
                    <div class="_dflex _mt-48 _mobile-hidden">
                        <button
                            class="private-lifestyle__button_arrow _mr-16"
                            type="button"
                            @click="onPrev"
                        >
                            <div
                                class="ico ico_size_16 ico-arrow-corner-left-bold  _mr-auto _ml-auto ico_color_white"
                            />
                        </button>
                        <button
                            class="private-lifestyle__button_arrow"
                            type="button"
                            @click="onNext"
                        >
                            <div
                                class="ico ico_size_16 ico-arrow-corner-right-bold _mr-auto _ml-auto ico_color_white"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="private-lifestyle__item-slider">
            <PrivateLifestyleItemSlider
                ref="slider"
                v-model="activeItem"
                :slides="slides"
            />
        </div>
    </div>
</template>
<script>
import PrivateLifestyleItemSlider from './PrivateLifestyleItemSlider.vue';

export default {
    name: 'PrivateLifestyle',
    components: {
        PrivateLifestyleItemSlider,
    },
    data() {
        return {
            activeItem: 0,
            slides: [
                {
                    id: '0',
                    title: 'Недвижимость',
                    description: 'Профессиональные консультации по недвижимости, специальные предложения от застройщиков на эксклюзивные лоты, выгодные условия ипотечного кредитования, коммерческие объекты, офисы, особняки, а также инвестиции в готовые арендные бизнесы',
                    image: '/local/templates/redesign/src/assets/img/private/private-lifestyle/realty.webp',
                    bg: '/local/templates/redesign/src/assets/img/private/private-lifestyle/realty_bg.webp',
                },
                {
                    id: '1',
                    title: 'Эксклюзивные путешествия',
                    description: 'Разработка индивидуальных приключенческих поездок по всему миру. Уникальные VIP-экспедиции: отправьтесь покорять Северный Полюс и Антарктиду, посетите удивительный животный мир Чукотки, Северных Курил, Камчатки и многое другое!',
                    image: '/local/templates/redesign/src/assets/img/private/private-lifestyle/travel.webp',
                    bg: '/local/templates/redesign/src/assets/img/private/private-lifestyle/travel_bg.webp',
                },
                {
                    id: '2',
                    title: 'Искусство',
                    description: 'Приобретение и продажа предметов искусства и антиквариата, формирование и управление коллекцией, консультации по эффективному инвестированию в произведения искусства. Оформление, транспортировка, хранение ценностей',
                    image: '/local/templates/redesign/src/assets/img/private/private-lifestyle/art.webp',
                    bg: '/local/templates/redesign/src/assets/img/private/private-lifestyle/art_bg.webp',
                },
                // {
                //     id: '3',
                //     title: 'Проход в бизнес-залы',
                //     description: 'Путешествуйте с комфортом. Безлимитные проходы в бизнес-залы аэропортов и вокзалов. ',
                //     image: '/local/templates/redesign/src/assets/img/private/private-lifestyle/business.webp',
                //     bg: '/local/templates/redesign/src/assets/img/private/private-lifestyle/business_bg.webp',
                //     btnText: 'Активация посещений',
                //     btnLink: '/private-banking/travel/'
                // },
                {
                    id: '4',
                    title: 'Предметы роскоши',
                    description: 'Инвестиции в бриллианты и винные коллекции, эксклюзивные ювелирные украшения и часы на заказ, автомобили класса «Люкс» и индивидуальный пошив одежды',
                    image: '/local/templates/redesign/src/assets/img/private/private-lifestyle/jevelry.webp',
                    bg: '/local/templates/redesign/src/assets/img/private/private-lifestyle/jevelry_bg.webp',
                },
                {
                    id: '5',
                    title: 'Красота и здоровье',
                    description: 'Организация консультаций и лечения за рубежом, программы комплексного check-up и программы восстановления, превентивная медицина и поддержание красоты',
                    image: '/local/templates/redesign/src/assets/img/private/private-lifestyle/beauty.webp',
                    bg: '/local/templates/redesign/src/assets/img/private/private-lifestyle/beauty_bg.webp',
                },
                {
                    id: '6',
                    title: 'Частная авиация и яхты',
                    description: 'Подбор и организация частного перелета, приобретение и продажа самолетов, вертолетов, яхт, корпоративные бизнес-перевозки (на любое количество пассажиров), аренда парусных и моторных яхт',
                    image: '/local/templates/redesign/src/assets/img/private/private-lifestyle/avia.webp',
                    bg: '/local/templates/redesign/src/assets/img/private/private-lifestyle/avia_bg.webp',
                },
            ],
        };
    },
    methods: {
        onNext() {
            this.$refs.slider?.next();
        },
        onPrev() {
            this.$refs.slider?.prev();
        },
    },
};
</script>
<style lang="scss">
@import '../../assets/scss/base/variables';
@import '../../assets/scss/base/mixins';
@import '../../assets/scss/base/functions';

.private-lifestyle {
    position: relative;
    @include fluid-1920('margin-bottom', 114px, 65px);

    &__header {
        width: 100%;

        position: absolute;
        @include mobile {
            position: relative;
        }

        @include fluid-1920('top', 380px);
        left: 0;
        @include mobile {
            top: unset;
            left: unset;
        }
    }

    &__header-content {
        position: relative;
        z-index: 1;
        @include fluid-1920('width', 384px);
        @include mobile {
            width: 100%;
        }
    }

    &__item-slider {
        @include fluid-1920('--private-lifestyle__item-slider-left', 350px, 0px);
        margin-left: auto;
        position: relative;

        top: 0;
        @include mobile {
            top: unset;
        }
        right: 0px;
        width: calc(100% - var(--private-lifestyle__item-slider-left));
        @include fluid-1920('margin-top', 0px, -185px);
    }

    &__button_arrow {
        border-radius: 50%;
        background-color: $grey-868;
        cursor: pointer;
        @include fluid('width', 32px);
        @include fluid('height', 32px);
        transition: background .3s ease;

        &:hover {
            background-color: $grey-517;
        }

        &:active {
            background-color: $grey-284;
        }
    }
}
</style>
